import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import _ from 'lodash'
import { matchScheduleTypes, SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { useSportsFilters } from 'projectSpecific/sports/useHelpers/useSportsFilters'
import { useContext, useEffect, useMemo, useState } from 'react'
import { Label } from 'semantic-ui-react'
import TeamResults from './TeamResults'
import { TeamOpps } from './TeamOpps'
import { TeamInsight } from './TeamInsight'
import MatchGrid from '../matches/MatchGrid'
import SportsSchedulesProvider from '../schedule/SportsSchedules'
import { gEnums } from 'global/enums/globalEnums'
import { CreatePlayoffContext } from 'projectSpecific/sports/create/CreatePlayoff'

const _teamSquareTypes = {
  teams: 'teams',
}

const _teamViewTypes = {
  schedule: 'schedule',
  teamInsights: 'teamInsights',
}

const TeamSquares = ({ teams, selectedTeam, playoffLevel }) => {

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { teams_info, matches_info } = sportsSeason_state ?? {}
  const { teams: teams_season } = teams_info ?? {}

  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state } = createPlayoffContext ?? {}
  const { playoff_info } = createPlayoff_state ?? {}
  const { playoffLevelTeams } = playoff_info ?? {}
  const teams_playoffGroup = playoffLevelTeams?.[playoffLevel]

  const { matches_groupInfo } = matches_info ?? {}
  const { matches_combined: matches } = matches_groupInfo ?? {}

  const { getTeamMatchGroups } = useSportsFilters()

  const teamMatchGroups = useMemo(() => {
    return getTeamMatchGroups(matches)
  }, [])

  const [currentMatchGroups, setCurrentMatchGroups] = useState({ startDate: {}, teams: {}, levels: {} })
  const [allGroups, setAllGroups] = useState([])
  const currentGroup = allGroups?.[allGroups.length - 1]

  const [selectedItem, setSelectedItem] = useState(_teamViewTypes.schedule)
  const handleClick_menu = (item) => setSelectedItem(item)

  const groupByTeam = (mz) => {
    const groupedByTeam = {};
    _.forEach(mz, (match) => {

      if (match._matchCollectionKey !== 'Non') return;

      const homeName = match?.home?.name;
      const awayName = match?.away?.name;

      if (homeName) {
        if (!groupedByTeam[homeName]) {
          groupedByTeam[homeName] = [];
        }
        groupedByTeam[homeName].push(match);
      }

      if (awayName) {
        if (!groupedByTeam[awayName]) {
          groupedByTeam[awayName] = [];
        }
        groupedByTeam[awayName].push(match);
      }
    });
    return groupedByTeam
  }

  useEffect(() => {
    if (matches) {

      const _currentMatchGroups = {
        teams: groupByTeam(matches),
      }

      setCurrentMatchGroups(_currentMatchGroups)

      const teams_filtered = selectedTeam ? [teams_season?.[selectedTeam?._itemKey]] : _.map(
        _.filter(teams_season, ts =>
          _.some(teams, t => t._itemKey === ts._itemKey)
        ),
        ts => {
          const match = _.find(teams, t => t._itemKey === ts._itemKey);
          return {
            ...ts,
            seed: match?.seed
          };
        }
      );

      const _allGroups = []

      const mis_teams = _.map(teams_filtered, team => ({
        name: team.name,
        _itemKey: team._itemKey,
        record: team.record,
        seed: team.seed
      }));

      _allGroups.push({
        key: _teamSquareTypes.teams,
        value: '',
        // caption: 'Non Section Matches',
        menuItems: _.sortBy(mis_teams, 'seed'),
        count: _.size(teams_season)
      })

      setAllGroups(_allGroups)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [matches, playoffLevel, selectedTeam]);

  const onClick_team = (baseType) => {
    // switch (baseType) {
    //   case _base.levels:
    //     const levelMatches = _.groupBy(matches, '_matchCollectionKey')
    //     addToGroup({ key: _matchSquareTypes.matchesByLevel, value: '', caption: 'Matches', menuItems: levelKeys(levelMatches), count: _.size(matches) })
    //     break;
    //   case _base.teams:
    //     const mis_t = _.keys(currentMatchGroups?.[baseType])
    //     addToGroup({ key: baseType, value: baseType, caption: _.startCase(baseType), menuItems: _.sortBy(mis_t) })
    //     break;
    //   case _base.startDate:
    //     const mis_d = _.keys(currentMatchGroups?.[baseType])
    //     addToGroup({ key: _matchSquareTypes.startDate, value: baseType, caption: _.startCase(baseType), menuItems: _.sortBy(mis_d) })
    //     break;
    // }
  }

  const altContentTeams = (team) => {
    const { name, record } = team ?? {}
    const { display } = record ?? {}
    const lbls = []
    lbls.push(<Label size='tiny' color='black'>{display}</Label>)
    return lbls
  }

  const fnSubContent_teams = (team) => {

    let itemContent = 'hmmmm';

    switch (selectedItem) {
      case _teamViewTypes.commonOpponents:
        itemContent = <TeamOpps team={team} noMid={true} />
        break;
      case _teamViewTypes.results:
        itemContent = <TeamResults team={team} teamMatchGroups={teamMatchGroups} />
        break;
      case _teamViewTypes.teamInsights:
        itemContent = <TeamInsight team={team} />
        break;
      case _teamViewTypes.schedule:
        itemContent = <SportsSchedulesProvider
          matchScheduleType={matchScheduleTypes.levelMatches}
          matchScheduleDisplayType={gEnums.matchScheduleDisplayTypes.teamSchedule}
          teamKey={team?._itemKey}
          noMid={true}
          fromSquares={true}
        />
        break;
      case _teamViewTypes.grid:
        itemContent = <MatchGrid selectedTeam={team} levelKey={playoffLevel} />
        break;
    }

    return <Wrapper
      content={itemContent}
      noMid={true}
    ></Wrapper>
  }

  const squares_teams = (menuItems) => <ItemMenuSquares
    menuItems={menuItems}
    imsType={_imsTypes.inline}
    fn_altContent={altContentTeams}
    fn_subContent={fnSubContent_teams}
    noItemIcon={true}
    onClick={onClick_team}
    ignoreMotion={true}
  />

  const ims_menu = () => <ItemMenuSquares
    menuItems={_teamViewTypes}
    imsType={_imsTypes.menu}
    onClick={handleClick_menu}
    activeItem={selectedItem}
  />

  const content = () => {
    if (!currentGroup) return;
    return squares_teams(currentGroup.menuItems)
  }

  return (
    <Wrapper
      header={ims_menu()}
      content={content()}
      wrapperType={wrapperTypes.paddedHeader}
    // noMid={true}
    ></Wrapper>
  )

}

export default TeamSquares